// extracted by mini-css-extract-plugin
module.exports = {"more-about-section":"moreAbouts_more-about-section__ieei0"};